import axios from 'axios';
import ArrayUtils from '../ArrayUtils';
// var pcm = require('./lib/pcm');

// var min = 1.0;
// var max = -1.0;

// pcm.getPcmData('http://www.thesubpro.com/UploadedFiles/mp3/UnlockMyBossEP2.mp3', { stereo: true, sampleRate: 44100 },
//   function(sample, channel) {
//     // Sample is from [-1.0...1.0], channel is 0 for left and 1 for right
//     min = Math.min(min, sample);
//     max = Math.max(max, sample);
//   },
//   function(err, output) {
//     if (err)
//       throw new Error(err);
//     console.log('min=' + min + ', max=' + max);
//   }
// );

export async function getPeakLevelData(PeakLevelFilesUrl) {
  // 讀取 PeakLevel 檔案
  const response = await axios({
    url: PeakLevelFilesUrl, //your url
    method: 'GET',
  });

  console.log('response');
  console.log(response);
  // create file link in browser's memory
  const dataArray = response.data.split('\n');

  // "frame:0    pts:0       pts_time:0"
  // "lavfi.astats.Overall.Peak_level=-12.103718"

  var r_Data = [];
  var _d3_Data = []; 
  var _levelList = [];
  var _svg_yList = [];
  var Peak_level_ABS_list = [];
  
  dataArray.forEach((element, index) => {
    // console.log(element);
    if (element.includes('pts_time')) {

      // 下一個物件
      let lastElement = dataArray[index + 1]; 

      // Peak_level  
      var Peak_level = ArrayUtils.getPeak_level(lastElement);

      // 取得 y 的位置
      let svg_y = 0;
      if (isNaN(Peak_level)) {
        Peak_level = 0;
      } else {
        svg_y = Math.abs(Peak_level); 
      }
  
      Peak_level_ABS_list.push(svg_y);
    }
  });

  var getResule = ArrayUtils.getMinMaxValue(Peak_level_ABS_list);
  const Peak_level_min = getResule[0];
  const Peak_level_max = getResule[1];
 

  dataArray.forEach((element, index) => {
    // console.log(element);
    if (element.includes('pts_time')) {

      // 下一個物件
      let lastElement = dataArray[index + 1];

      // pts_time 
      let pts_time = ArrayUtils.getPts_time(element);

      // Peak_level  
      var Peak_level = ArrayUtils.getPeak_level(lastElement);

      // 取得 y 的位置
      let svg_y = 0;
      if (isNaN(Peak_level)) {
        Peak_level = 0;
      } else {
        var pk_abs = Math.abs(Peak_level);
        svg_y = 50 - pk_abs;
      } 

      const pSecond = pts_time;
      const p_x = pSecond * 40; // 時間
     
      // 累積 d3 的資料
      r_Data.push({
        x: pSecond,
        y: svg_y,
      });
      _d3_Data.push({
        x: p_x,
        y: 0,
        width: 5,
        height: Math.abs(Peak_level),
      });

      // 累積波長總資料
      // _levelList.push(Peak_level);
      // _svg_yList.push(svg_y);
    }
  });


  return [r_Data, _d3_Data];
}



// WEBPACK FOOTER //
// ./src/helper/PeakLevel/index.js